module.exports = __webpack_public_path__ + "img/tab.8c9e812a.png";